var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.99,
    height: 11.99,
    viewBox: "0 0 11.99 11.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#343434;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-73.99 -147.978)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.99 147.978)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.985,147.978a6,6,0,1,0,6,6A6,6,0,0,0,79.985,147.978Zm-.321,6.688a1.8,1.8,0,0,1-.728,1.165,1.657,1.657,0,0,1-.288.154,1.218,1.218,0,0,0-.76,1.2,1.652,1.652,0,0,1-.106.489.577.577,0,0,1-.892.247,5.009,5.009,0,0,1-.24-7.679.578.578,0,0,1,.956.3,1.283,1.283,0,0,1,0,.447s-.411,1.5.871,1.838A1.6,1.6,0,0,1,79.664,154.666Zm2.866,2.465-.025.039a1.608,1.608,0,0,1-1.824.625c-.1-.03-.19-.063-.277-.1a.663.663,0,0,1-.133-1.161,4.9,4.9,0,0,1,.9-.476,1.156,1.156,0,0,1,1.267.262A.661.661,0,0,1,82.531,157.132Zm1.037-1.629a1.969,1.969,0,0,1-.117-.962.793.793,0,0,0-.512-.825,1.932,1.932,0,0,1-.283-.135,1.963,1.963,0,0,1-.818-1.057,1.118,1.118,0,0,1-.061-.323,2.374,2.374,0,0,1,.913-1.834l.027-.023a.54.54,0,0,1,.73.013,5.015,5.015,0,0,1,1.335,5.072A.649.649,0,0,1,83.568,155.5Z",
    transform: "translate(-73.99 -147.978)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.e22b1c9f.svg";
export { ForwardRef as ReactComponent };